import { Component, OnInit, Input, ViewEncapsulation, Output, EventEmitter } from '@angular/core';
import {PermissionsService} from "../../services/permissions/permissions.service";

@Component({
  selector: 'app-pagination',
  templateUrl: './pagination.component.pug',
  styleUrls: ['./pagination.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class AppPaginationComponent implements OnInit {
  @Input() rowsInput = [20, 50, 100];
  @Input() rowsPerView = this.rowsInput[0];
  @Input() total = 20;
  @Input() currentPage = 1;
  @Input() isDropup = false;
  @Output() pageChange = new EventEmitter();
  @Output() pageSizeChange = new EventEmitter();
  totalPages = 2;

  constructor() {}

  ngOnInit(): void { }

  onSelect(selection){
    this.rowsPerView = Number(selection);
    this.pageSizeChange.emit(this.rowsPerView);
    return false;
  }

  onPageChange(event){
    let offset = event.page*this.rowsPerView;
    this.pageChange.emit(event.page);
  }

  isPaginationRequired(){
    return this.total > this.rowsPerView
  }

}
